import PropTypes from 'prop-types';
import React from 'react';
import { containerApp } from '../../../main';
import MenuIcon from '../../../../icons/icon-menu-hamburguer.svg';
import { useBreakpoints } from '../../../modules/infra/dls/hooks/use-get-breakpoints';
import { HeadingS } from '../../../modules/infra/dls/components/typography/typography';

const Layout = ({ toggleSidebar, title, controls, content }) => {
  const { isTabletOrSmaller } = useBreakpoints();

  return (
    <div>
      <div className="c-header-primary">
        {isTabletOrSmaller ? (
          <>
            <MenuIcon
              onClick={toggleSidebar}
              display-if={!containerApp.isActive()}
              data-testid="open-side-menu-button"
              className="c-header-hamburger-menu-icon"
            />
            <HeadingS
              className={`c-header-mobile-title ${containerApp.isActive() && 'container-app-title'}`}
              color="primary"
            >
              {title}
            </HeadingS>
          </>
        ) : (
          <h2 className="c-header-primary__title">
            <span display-if={!containerApp.isActive()}>{title}</span>
          </h2>
        )}
        <div className="u-ph-">{controls}</div>
      </div>
      <div>{content}</div>
    </div>
  );
};
Layout.propTypes = {
  toggleSidebar: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  controls: PropTypes.node,
};
Layout.defaultProps = {
  controls: null,
};

export default Layout;
